jQuery(document).ready(function ($) {
	$('.pdpMain__sizeButtonImage').each(function() {
		var heightName = $(this).attr('alt');
		var heightArray = heightIconArray.split(',');
		for (var i = 0; i < heightArray.length; i++) {
			var thisArray = heightArray[i].split('|');
			var thisHeight = thisArray[0];
			var thisImage = thisArray[1];
			if (thisHeight == heightName) {
				$(this).attr('src', thisImage);
				$(this).css('opacity', '1');
				break;
			}
		}
	});

	$('.comparisonItem__heightImage').each(function() {
		var heightName = $(this).attr('alt');
		var heightArray = heightIconArray.split(',');
		for (var i = 0; i < heightArray.length; i++) {
			var thisArray = heightArray[i].split('|');
			var thisHeight = thisArray[0];
			var thisImage = thisArray[1];
			if (thisHeight == heightName) {
				$(this).attr('src', thisImage);
				$(this).css('opacity', '1');
				break;
			}
		}
	});

	// mutation observer for shop pay button display
	const accelStaging = document.getElementById('AccelStaging');
	if (accelStaging && typeof MutationObserver !== "undefined") {
		const showShopPayButton = function() {
			const hasShopPay = !!accelStaging.querySelector('shopify-accelerated-checkout');
			const $btn = $('.btn--shopPay');
			if (hasShopPay) {
				$btn.show();
			} else {
				$btn.hide();
			}
		};

		showShopPayButton();
		const observer = new MutationObserver(function(mutationsList, observer) {
			showShopPayButton();
		});

		observer.observe(accelStaging, {
			childList: true,
			subtree: true
		});

		showShopPayButton();
	}


	function preloadImage(url) {
		if (url) {
			var img = new Image();
			img.src = url;
		}
    }

	$('#variantData').find('option').each(function() {
		preloadImage($(this).attr('data-image-one'));
		preloadImage($(this).attr('data-image-two'));
		preloadImage($(this).attr('data-image-three'));
		preloadImage($(this).attr('data-image-four'));
		preloadImage($(this).attr('data-image-five'));
		preloadImage($(this).attr('data-image-six'));
	});

	function getVariantData(optionOne, optionTwo = null, optionThree = null) {
		var matchString = optionOne;
		if (optionTwo) {
			matchString += ' / ' + optionTwo;
		}
		if (optionThree) {
			matchString += ' / ' + optionThree;
		}
		var targetVariant = $('#variantData').find('[data-title="' + matchString + '"]');
		var variantData = {	
			title: targetVariant.attr('data-title'),
			id: targetVariant.attr('value'),
			available: targetVariant.attr('data-available'),
			price: targetVariant.attr('data-price'),
			raw_price: targetVariant.attr('data-raw-price'),
			compare_price: targetVariant.attr('data-compare-price'),
			image_one: targetVariant.attr('data-image-one'),
			image_two: targetVariant.attr('data-image-two'),
			image_three: targetVariant.attr('data-image-three'),
			image_four: targetVariant.attr('data-image-four'),
			image_five: targetVariant.attr('data-image-five'),
			image_six: targetVariant.attr('data-image-six'),
			video_one: targetVariant.attr('data-video-one'),
			video_two: targetVariant.attr('data-video-two'),
			video_three: targetVariant.attr('data-video-three'),
			video_four: targetVariant.attr('data-video-four'),
			video_five: targetVariant.attr('data-video-five'),
			video_six: targetVariant.attr('data-video-six'),
			color: targetVariant.attr('data-color'),
			height: targetVariant.attr('data-height')
		};
		return variantData;
	}

	function populateImageGallery(){
        $('.pdpMain__imageBlock').each(function(index){
            var $imageBlock = $(this);
            var $image = $imageBlock.find('.pdpMain__image');
            var imageURL = $image.attr('src');
            var imageAlt = $image.attr('alt');

            // Get corresponding slide and thumbnail elements using .eq()
            var $slide = $('.slideshowModal__slide').eq(index);
            var $thumbnail = $('.slideshowModal__thumbnail').eq(index);

            // Populate main slide image
            if ($slide.length && imageURL) {
                $slide.find('.slideshowModal__slideImage').attr('src', imageURL);
                $slide.find('.slideshowModal__slideImage').attr('alt', imageAlt || '');
            }

            // Populate thumbnail image
            if ($thumbnail.length && imageURL) {
                $thumbnail.find('.slideshowModal__thumbnailImage').attr('src', imageURL);
                $thumbnail.find('.slideshowModal__thumbnailImage').attr('alt', imageAlt || '');
            }
        });
    }
    populateImageGallery();

	function displayVariantData(variantData) {
		if (variantData.image_one) {
			$('.pdpMain__imageBlock[data-image="0"] .pdpMain__image').attr('src', variantData.image_one);
			$('.pdpMain__imageBlock[data-image="1"] .pdpMain__image').attr('src', variantData.image_two);
			$('.pdpMain__imageBlock[data-image="2"] .pdpMain__image').attr('src', variantData.image_three);
			$('.pdpMain__imageBlock[data-image="3"] .pdpMain__image').attr('src', variantData.image_four);
			$('.pdpMain__imageBlock[data-image="4"] .pdpMain__image').attr('src', variantData.image_five);
			$('.pdpMain__imageBlock[data-image="5"] .pdpMain__image').attr('src', variantData.image_six);
		}
		if (variantData.video_one) {
			$('.pdpMain__videoBlock[data-video="0"] .pdpMain__video').attr('src', variantData.video_one);
		}
		if (variantData.video_two) {
			$('.pdpMain__videoBlock[data-video="1"] .pdpMain__video').attr('src', variantData.video_two);
		}
		if (variantData.video_three) {
			$('.pdpMain__videoBlock[data-video="2"] .pdpMain__video').attr('src', variantData.video_three);
		}
		if (variantData.video_four) {
			$('.pdpMain__videoBlock[data-video="3"] .pdpMain__video').attr('src', variantData.video_four);
		}
		if (variantData.video_five) {
			$('.pdpMain__videoBlock[data-video="4"] .pdpMain__video').attr('src', variantData.video_five);
		}
		if (variantData.video_six) {
			$('.pdpMain__videoBlock[data-video="5"] .pdpMain__video').attr('src', variantData.video_six);
		}

		$('[per-unit-price]').text('$' + variantData.price);
		$('.pdpMain__optionPill--height .pdpMain__optionPillText').text(variantData.height);
		$('.pdpMain__optionPill--color .pdpMain__optionPillText').text(variantData.color);

		if (variantData.available == 'true') {
			$('[add-to-cart]').prop('disabled', false);
			$('[add-to-cart] span').text('Add To Cart');
		}
		else {
			$('[add-to-cart]').prop('disabled', true);
			$('[add-to-cart] span').text('Out Of Stock');
		}

		var totalPrice = ((parseInt(variantData.raw_price) * parseInt(pdpState.quantity)) / 100).toFixed(2);
		$('.pdpMain__totalPriceValueText').text(totalPrice);

		$('.pdpMain__measurementItem--height .pdpMain__measurementItemValueText').text(variantData.height);
		$('.pdpMain__measurementItem--length .pdpMain__measurementItemValueText').text(parseInt(pdpState.lengthStep) * parseInt(pdpState.quantity));

		$('.pdpMain__colorLabelValue').text(variantData.color);

		populateImageGallery();
	}

	var pdpState = {
		variantTitle: $('#variantData').find('option').first().attr('data-title'),
		optionOne: null,
		optionTwo: null,
		optionThree: null,
		variantData: null,
		colorButtons: false,
		heightButtons: false,
		quantity: 1,
		lengthStep: 4
	}

	function setPdpState(optionOne, optionTwo = null, optionThree = null) {
		pdpState.optionOne = optionOne;
		pdpState.optionTwo = optionTwo;
		pdpState.optionThree = optionThree;
		var variantTitle = optionOne;
		if (optionTwo) {
			variantTitle += ' / ' + optionTwo;
		}
		if (optionThree) {
			variantTitle += ' / ' + optionThree;
		}
		pdpState.variantTitle = variantTitle;
		pdpState.variantData = getVariantData(optionOne, optionTwo, optionThree);
		pdpState.lengthStep = $('[data-step]').attr('data-step');
	}

	function updatePdpOption(option, value) {
		if (option == 0) {
			pdpState.optionOne = value;
		}
		else if (option == 1) {
			pdpState.optionTwo = value;
		}
		else if (option == 2) {
			pdpState.optionThree = value;
		}
		setPdpState(pdpState.optionOne, pdpState.optionTwo, pdpState.optionThree);
		displayVariantData(getVariantData(pdpState.optionOne, pdpState.optionTwo, pdpState.optionThree));
	}

	if ($('.pdpMain__colorSwatch').length) {
		pdpState.colorButtons = true;
	}
	if ($('.pdpMain__sizeButton').length) {
		pdpState.heightButtons = true;
	}

	if (pdpState.colorButtons) {
		pdpState.optionOne = $('.pdpMain__colorSwatch--active').attr('data-color');
	}
	if (pdpState.heightButtons) {
		pdpState.optionTwo = $('.pdpMain__sizeButton--active').attr('data-size');
	}

	setPdpState(pdpState.optionOne, pdpState.optionTwo, pdpState.optionThree);
	displayVariantData(getVariantData(pdpState.optionOne, pdpState.optionTwo, pdpState.optionThree));

	console.log(pdpState);

	$('.pdpMain__colorSwatch').on('click', function(){
		if (!$(this).hasClass('pdpMain__colorSwatch--active')){
			var color = $(this).attr('data-color');
			$('.pdpMain__colorSwatch').removeClass('pdpMain__colorSwatch--active');
			$(this).addClass('pdpMain__colorSwatch--active');
			updatePdpOption(0, color);
		}
	});

	$('.pdpMain__sizeButton').on('click', function(){
		if (!$(this).hasClass('pdpMain__sizeButton--active')){
			var size = $(this).attr('data-size');
			$('.pdpMain__sizeButton').removeClass('pdpMain__sizeButton--active');
			$(this).addClass('pdpMain__sizeButton--active');
			updatePdpOption(1, size);
		}
	});

	$('[qty-selector]').on('change', function(){
		if (parseInt($(this).val()) < 1){
			$(this).val(1);
		}
		var quantity = $(this).val();
		pdpState.quantity = parseInt(quantity);
		displayVariantData(getVariantData(pdpState.optionOne, pdpState.optionTwo, pdpState.optionThree));
	});

	$('.pdpMain__quantityButton').on('click', function(){
		if ($(this).hasClass('pdpMain__quantityButton--minus')){
			if (pdpState.quantity > 1){
				pdpState.quantity--;
			}
		}
		else if ($(this).hasClass('pdpMain__quantityButton--plus')){
			pdpState.quantity++;
		}
		$('[qty-selector]').val(pdpState.quantity).change();
	});

	$('[add-to-cart]').on('click', function(){
		console.log("add to cart button clicked");
		addToCart(pdpState.variantData.id, pdpState.quantity, true);
	});
});
